import React from 'react';
export function EliteSection() {
  return <section className="w-full bg-[#001a2d] py-16 px-4" data-id="element-74">
      <div className="max-w-4xl mx-auto" data-id="element-75">
        <div className="text-center mb-10" data-id="element-76">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-4" data-id="element-77">
            🕊️ ¿Qué agrega el{' '}
            <span className="text-[#00B4D8]" data-id="element-78">Kit Adaptaciones al Aula Pro</span>
            ?
          </h2>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto" data-id="element-79">
            Vos ya tenés el material para el 80% del aula. El MegaPack +
            Adaptaciones resuelve el 20% que más tiempo te consume.
          </p>
        </div>

        {/* Comparison Table */}
        <div className="bg-black border border-[#00B4D8]/30 rounded-2xl overflow-hidden mb-12" data-id="element-80">
          <div className="grid grid-cols-1 sm:grid-cols-3 bg-[#000d1a] border-b border-[#00B4D8]/30" data-id="element-81">
            <div className="p-4 font-bold text-white hidden sm:block" data-id="element-82">
              Situación
            </div>
            <div className="p-4 font-bold text-gray-400 text-center border-l border-[#00B4D8]/30" data-id="element-83">
              Sin Adaptaciones
            </div>
            <div className="p-4 font-bold text-[#00B4D8] text-center border-l border-[#00B4D8]/30" data-id="element-84">
              Con Adaptaciones
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-85">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-86">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-87">
                Situación:
              </span>
              Valentina no puede hacer la actividad estándar del subjonctif
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-88">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-89">
                Sin Adaptaciones:
              </span>
              Improvisás algo "más fácil" en el momento
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00B4D8]/5" data-id="element-90">
              <span className="sm:hidden font-bold text-[#00B4D8] block mb-1" data-id="element-91">
                Con Adaptaciones:
              </span>
              Imprimís la Ficha de Capa 1 con banco de palabras y pictogramas.
              30 segundos.
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-92">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-93">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-94">
                Situación:
              </span>
              Marcos necesita el examen diferente el día de la evaluación
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-95">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-96">
                Sin Adaptaciones:
              </span>
              Armás otra evaluación el domingo a la noche
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00B4D8]/5" data-id="element-97">
              <span className="sm:hidden font-bold text-[#00B4D8] block mb-1" data-id="element-98">
                Con Adaptaciones:
              </span>
              Abrís la Evaluación Diferenciada lista. Ya está.
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-99">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-100">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-101">
                Situación:
              </span>
              La directora pide ver el registro de adecuaciones
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-102">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-103">
                Sin Adaptaciones:
              </span>
              Buscás algo que no encontrás
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00B4D8]/5" data-id="element-104">
              <span className="sm:hidden font-bold text-[#00B4D8] block mb-1" data-id="element-105">
                Con Adaptaciones:
              </span>
              Mostrás la plantilla de seguimiento firmada. Profesional.
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-106">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-107">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-108">
                Situación:
              </span>
              Tenés un alumno que termina en 2 minutos y se aburre
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-109">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-110">
                Sin Adaptaciones:
              </span>
              Le das más de lo mismo
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00B4D8]/5" data-id="element-111">
              <span className="sm:hidden font-bold text-[#00B4D8] block mb-1" data-id="element-112">
                Con Adaptaciones:
              </span>
              Le das la Ficha de Capa 2 con extensión. Desafío real.
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-113">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-114">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-115">
                Situación:
              </span>
              Alumno con dislexia no puede leer la consigna en francés
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-116">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-117">
                Sin Adaptaciones:
              </span>
              Dictás o simplificás en el momento
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00B4D8]/5" data-id="element-118">
              <span className="sm:hidden font-bold text-[#00B4D8] block mb-1" data-id="element-119">
                Con Adaptaciones:
              </span>
              Imprimís la ficha de Lettura Simplificée. Ya está hecha.
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3" data-id="element-120">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-121">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-122">
                Situación:
              </span>
              Grupo con A1 y A2 juntos — no sabés a quién explicarle
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-123">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-124">
                Sin Adaptaciones:
              </span>
              Explicás al promedio y perdés a todos
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00B4D8]/5" data-id="element-125">
              <span className="sm:hidden font-bold text-[#00B4D8] block mb-1" data-id="element-126">
                Con Adaptaciones:
              </span>
              Usás el Sistema de 3 Capas. Todos trabajan al mismo tiempo.
            </div>
          </div>
        </div>

        {/* Features List */}
        <h3 className="text-2xl font-black text-white text-center mb-8" data-id="element-127">
          ✅ EL KIT ADAPTACIONES AL AULA PRO INCLUYE:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-128">
          <div className="bg-black border border-[#00B4D8]/20 rounded-xl p-5" data-id="element-129">
            <h4 className="text-[#00B4D8] font-bold text-lg mb-2" data-id="element-130">
              🔵 Sistema de 3 Capas (Andamiaje Progresivo)
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-131">
              El MISMO bloque del MegaPack en 3 versiones de soporte: CAPA 0 /
              CAPA 1 / CAPA 2. Todos trabajan el mismo tema al mismo tiempo.
              Ningún alumno queda excluido. Ningún alumno se aburre. El docente
              no planifica doble.
            </p>
          </div>
          <div className="bg-black border border-[#00B4D8]/20 rounded-xl p-5" data-id="element-132">
            <h4 className="text-[#00B4D8] font-bold text-lg mb-2" data-id="element-133">
              🖼️ Fichas de Andamiaje Visual — Pictogramas + Glosario
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-134">
              6 fichas de soporte visual para los bloques temáticos principales:
              saludos, familia, cuerpo, passé composé, subjonctif y
              conditionnel. Para alumnos que no procesan el texto pero sí el
              diagrama o la imagen.
            </p>
          </div>
          <div className="bg-black border border-[#00B4D8]/20 rounded-xl p-5" data-id="element-135">
            <h4 className="text-[#00B4D8] font-bold text-lg mb-2" data-id="element-136">
              📝 Evaluaciones Diferenciadas — Listas para Imprimir
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-137">
              Versiones diferenciadas de evaluación por nivel (A1 / A2 / B1) con
              3 capas de complejidad: banco de palabras disponible, consignas
              simplificadas y modalidad oral sustitutiva. Nunca más armás otro
              examen el domingo a la noche.
            </p>
          </div>
          <div className="bg-black border border-[#00B4D8]/20 rounded-xl p-5" data-id="element-138">
            <h4 className="text-[#00B4D8] font-bold text-lg mb-2" data-id="element-139">
              📋 Plantilla de PPI para Francés
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-140">
              Proyecto Pedagógico Individual pre-diseñado para la materia
              Francés Lengua Extranjera. Con objetivos, estrategias, sistema de
              acreditación diferenciada y firmas de acuerdo. Listo para
              presentar ante directivos y equipos de orientación.
            </p>
          </div>
          <div className="bg-black border border-[#00B4D8]/20 rounded-xl p-5" data-id="element-141">
            <h4 className="text-[#00B4D8] font-bold text-lg mb-2" data-id="element-142">
              📨 Generador de Informes de Trayectoria
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-143">
              Plantilla completa para completar el informe trimestral de un
              alumno en inclusión en 5–10 minutos. Con descripción del punto de
              partida, logros del período, adaptaciones realizadas y plan para
              el próximo trimestre. Modelo de párrafo narrativo incluido.
            </p>
          </div>
          <div className="bg-black border border-[#00B4D8]/20 rounded-xl p-5" data-id="element-144">
            <h4 className="text-[#00B4D8] font-bold text-lg mb-2" data-id="element-145">
              📖 Guía de Instrucciones Simplificadas
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-146">
              Traducción de todas las consignas del Megapack al lenguaje más
              accesible: Capa 2 (simplificado), Capa 1 (mínimo con íconos) y
              Capa 0 (solo pictogramas). Para alumnos con dislexia, TDAH, NEE o
              bajo nivel de lectocomprensión en español.
            </p>
          </div>
          <div className="bg-black border border-[#00B4D8]/20 rounded-xl p-5" data-id="element-147">
            <h4 className="text-[#00B4D8] font-bold text-lg mb-2" data-id="element-148">
              👥 Protocolo "Aula Cohesionada"
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-149">
              Sistema de gestión para grupos heterogéneos donde conviven A1 y A2
              (o A2 y B1) en el mismo espacio. Cronograma de clase inclusiva de
              40/80 minutos. Regla 70/30 aplicada a grupos mixtos. Para que el
              docente pueda atender todos los niveles sin perder el hilo.
            </p>
          </div>
          <div className="bg-black border border-[#00B4D8]/20 rounded-xl p-5" data-id="element-150">
            <h4 className="text-[#00B4D8] font-bold text-lg mb-2" data-id="element-151">
              📊 Registro de Seguimiento Individual
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-152">
              Planilla mensual para documentar el progreso de cada alumno en
              inclusión: participación, producción, ajustes realizados y metas
              del próximo mes. Evidencia profesional lista para mostrar cuando
              la institución lo requiera.
            </p>
          </div>
        </div>
      </div>
    </section>;
}